import { create } from 'zustand';

import { serializeCurrency } from '../lib';
import { ICurrency } from '../types';
import { ICurrenciesStore } from './types';

export const useCurrenciesStore = create<ICurrenciesStore>((set) => ({
  currenciesById: new Map(),
  currencies: [],
  setCurrencies: (state) => {
    const currenciesById = new Map<string, ICurrency>();
    const currencies = state.map((currency) => {
      const serializedCurrency = serializeCurrency(currency);
      currenciesById.set(currency.id, serializedCurrency);
      return serializedCurrency;
    });

    set({
      currencies,
      currenciesById,
    });
  },
}));
